/*=========================================================================================
  File Name: mutations.js
  Namespace: quizzes
  Description: Vuex Store - Quiz mutations
==========================================================================================*/
import {
  quizFactory
} from './factories'
import cloneDeep from 'lodash.clonedeep'
// import { renameKey } from '@/utils/utils'

const mutations = {
  STORE_CURRENT_QUIZ(state, quiz) {
    state.quiz = { ...state.quiz, ...quiz }
  },
  STORE_CURRENT_QUESTIONS(state, questions) {
    state.questions = cloneDeep(questions)
  },
  STORE_CURRENT_ANSWERS(state, answers) {
    state.answers = cloneDeep(answers)
  },
  STORE_QUESTION(state, question) {
    state.questions = {
      ...state.questions,
      [question.id]: {...question}
    }
  },
  STORE_ANSWER(state, { answer, questionId, addFunc }) {
    state.answers = {
      ...state.answers,
      [answer.id]: {
        ...answer
      }
    }
    if (addFunc) {
      addFunc(state.answers, answer.id, answer)
      state.questions[questionId].answers.push(answer.id)
    }
  },
  RESET_CURRENT_QUIZ(state) {
    state.quiz = quizFactory()
    state.questions = {}
    state.answers = {}
  },
  STORE_LIST_QUIZZES(state, passes) {
    state.quizList = {
      ...state.quizList,
      ...passes.entries
    }
    state.count = passes.count
    state.next = passes.next
    state.previous = passes.previous
    state.results = [...passes.results]
  },
  DELETE_QUESTION(state, {
      index,
      deleteFunc
    }) {
    const arrayToDelete = state.questions[index].answers
    let deleteKey = null
    for (let a = 0, l = arrayToDelete.length; a < l; a++) {
      deleteKey = arrayToDelete[a]
      deleteFunc(state.answers, deleteKey)
    }
    deleteFunc(state.questions, index)
  },
  DELETE_ANSWER(state, {
    answerId,
    questionId,
    deleteFunc
  }) {
    deleteFunc(state.answers, answerId)
    state.questions[questionId].answers.splice(state.questions[questionId].answers.indexOf(answerId), 1)
  },
  DELETE_ANSWER_FROM_QUESTION(state, {
    answerId,
    questionId
  }) {
    state.questions[questionId].answers.splice(state.questions[questionId].answers.indexOf(answerId), 1)
  },
  STORE_QUIZ_TO_LIST(state, quiz) {
    state.quizList = {
      ...state.quizList,
      ...quiz
    }
  }
}

export default mutations

